import { MRT_ColumnDef, MRT_RowData } from 'material-react-table';
import { EstadoComponente } from '@/shared/components/ui';
import { useFetchOrdenesCompras } from '@/shared/actions/erp';
import { useCheckPermissions, useTableFilter, useTableServerSideFiltering } from '@/shared/hooks';
import GeneralTable from '@/shared/components/ui/GeneralTable';
import { } from '@/shared/interfaces';
import { Button, Grid, Typography } from '@mui/material';
import { useCallback, useMemo } from 'react';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import { useState } from 'react';
import { SampleTable } from '@/shared/components/ui';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { IUbicacionProducto } from '@/shared/interfaces/erp/inventario';
import { cellNotFilter, EstadosProcesoEnumChoice, formatDateWithTimeCell, gridSize, TABLE_CONSTANTS_COLUMS } from '@/shared';
import { PermissionsEnum } from '@/auth/interfaces';
import Chip from '@mui/material/Chip';
import { OrdenesCompra } from '@/shared/interfaces/erp/compras/ordenes-compra.interface';
import ModalObservacionGeneral from '@/shared/components/ui/ModalObservacionesGeneral';
import ActionsBar from '@/shared/components/ui/ActionBar';
import { renderEmpty } from '@/shared/utils/renderEmpty';
import { toast } from 'react-toastify';
import { useFileDowloadDoc } from '@/shared/hooks/useDownloadFileDoc';
import { useFilePrint } from '@/shared/hooks/usePrintFile';
import ShowNamesUser from '@/shared/components/ui/ShowNamesUser/showNamesUser';
import PersonIcon from '@mui/icons-material/Person';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

export default function SolicitudOrdenCompraFinalizadaPagina() {
  useCheckPermissions(PermissionsEnum.api_view_ordencompra);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [details, setDetails] = useState<IUbicacionProducto[]>([]);
  const [url_pdf, set_urlPdf] = useState()
  const [userCreate, setUserCreate] = useState('')
  const [usuarioSolicitud, setUsuarioSolicitud] = useState('')
  const [numberFactura, setNumberFactura] = useState('')
  const [numberRemision, setNumberRemision] = useState('')

  //
  const { downloadFile } = useFileDowloadDoc()
  const { printFile } = useFilePrint()


  /////******dowload */
  const handleDowload = async () => {
    if (!url_pdf) return toast.error('No existe archivo PDF generado.')
    downloadFile({
      url: url_pdf,
      nameFile: 'Orden_Finalizada',
      extensionFile: 'pdf'
    })
  }
  const handlePrint = async () => {
    if (!url_pdf) return toast.error('No existe ningún archivo PDF generado.')
    printFile({ urlPdf: url_pdf })
  }

  const columns = useMemo<MRT_ColumnDef<OrdenesCompra>[]>(() => [
    {
      ...cellNotFilter,
      accessorKey: 'detalles',
      header: 'Producto',
      size: 20,
      enableColumnActions: false,
      Cell: ({ row }) => {
        return (
          <Button
            variant='text'
            color='primary'
            startIcon={<VisibilityIcon />}
            onClick={() => onDetails(row.original)}
          >
            {'Ver'}
          </Button>
        );
      }
    },
    {
      accessorKey: 'numero_referencia',
      header: 'numero referencia',
    },
    {
      accessorKey: 'solicitud_ingreso',
      header: 'solicitud ingreso',
      Cell: ({ row }) => row.original?.solicitud_ingreso || 'N/A'
    },
    {
      accessorKey: 'plazo_pago',
      header: 'plazo pago',
      size: 10
    },
    {
      ...cellNotFilter,
      accessorKey: 'fecha_orden',
      header: 'fecha orden',
      Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_orden')
    },
    {
      ...cellNotFilter,
      accessorKey: 'fecha_compra',
      header: 'fecha Compra',
      Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_compra')
    },
    {
      ...cellNotFilter,
      accessorKey: 'fecha_entrega',
      header: 'fecha entrega',
      Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_entrega')
    },
    {
      accessorKey: 'forma_pago_data.nombre',
      header: 'forma_pago',
      Cell: ({ row }) => row.original?.forma_pago_data?.nombre || 'N/A'
    },

    {
      accessorKey: 'proveedor_data.razon_social',
      header: 'proveedor',
    },
    {
      ...cellNotFilter,
      accessorKey: 'observaciones.observacionCerrarOrden',
      header: 'observacion de cierre de orden',
      size: 300,
      //Cell: ({ row }) => row.original.observaciones?.observacionCerrarOrden || 'N/A'
      Cell: ({ row }) => {
        return (
          <ModalObservacionGeneral
            title='Observación'
            texto={row.original?.observaciones?.observacionCerrarOrden || 'N/A'}
          />
        )
      }
    },
    {
      ...cellNotFilter,
      accessorKey: 'observaciones.observacionCreador',
      header: 'observacion del generador orden',
      size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
      //Cell: ({ row }) => row.original.observaciones?.observacionCerrarOrden || 'N/A'
      Cell: ({ row }) => {
        return (
          <ModalObservacionGeneral
            title='Observación'
            texto={row.original?.observaciones?.observacionCreador || 'N/A'}
          />
        )
      }
    },
    {
      ...cellNotFilter,
      accessorKey: 'observaciones.observacionRevisor',
      header: 'observacion del Revisor orden',
      size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
      //Cell: ({ row }) => row.original.observaciones?.observacionCerrarOrden || 'N/A'
      Cell: ({ row }) => {
        return (
          <ModalObservacionGeneral
            title='Observación'
            texto={row.original?.observaciones?.observacionRevisor || 'N/A'}
          />
        )
      }
    },

    {
      ...cellNotFilter,
      enableColumnActions: false,
      accessorKey: "estado_solicitud",
      header: "estado",
      size: 200,
      Cell: ({ row }) =>
        row.original.estado_orden != null ? (
          <EstadoComponente
            backgroundColor="green"
            texto={row.original.estado_orden || ""}
          />
        ) : null,
    },
  ], [])


  const onDetails = useCallback((e: MRT_RowData) => {
    const ultimo = e.ingreso_inventario_data?.at(-1)
    const factura = ultimo?.numero_factura?.trim()
    const remision = ultimo?.numero_guia_remision?.trim()
    setNumberFactura(factura)
    setNumberRemision(remision)
    //
    setUserCreate(e?.user_create)
    setUsuarioSolicitud(e?.solicitud_ingreso_data?.user)
    set_urlPdf(e?.url_pdf)
    setDetails(e?.detalles || [])
    setIsModalOpen(true);

  }, [])

  const columnsProductosDetallePedidosDb: MRT_ColumnDef<IUbicacionProducto>[] = useMemo<
    MRT_ColumnDef<IUbicacionProducto>[]
  >(
    () => [
      {
        accessorKey: 'codigo',
        header: 'Código',
        Cell: ({ row }) => row.original?.codigo || 'N/A',
      },
      {
        accessorKey: 'descripcion',
        header: 'Descripción',
        Cell: ({ row }) => row.original?.producto_data?.descripcion || 'N/A',
      },
      {
        accessorKey: 'producto_data.unidad_medida',
        header: 'Unidad Medida',
        Cell: ({ row }) => row.original?.producto_data?.unidad_medida || 'N/A',
      },
      {
        accessorKey: 'producto_data.modelo_producto',
        header: 'Modelo',
        Cell: ({ row }) => renderEmpty(row.original?.producto_data?.modelo_producto)
      },
      {
        accessorKey: 'producto_data.marca_producto',
        header: 'Marca',
        Cell: ({ row }) => renderEmpty(row.original?.producto_data?.marca_producto)
      },
      {
        accessorKey: 'producto_data.categoria_producto',
        header: 'Categoria',
      },
      {
        accessorKey: 'cantidad_aprobada',
        header: 'Cant. Aprobada',
        size: 150,
        Cell: ({ row }) => row.original?.cantidad_aprobada || 'N/A'
      },
      {
        accessorKey: 'cantidad',
        header: 'Cant. Solicitada'
      },
      {
        accessorKey: 'cantidad_recibida',
        header: 'Cant. Recibida',
        Cell: ({ row }) => {
          const { cantidad_aprobada, cantidad_recibida } = row.original
          const despachoTotal = cantidad_aprobada === cantidad_recibida
          return (
            <Chip
              label={cantidad_recibida}
              style={{
                backgroundColor: despachoTotal ? 'green' : 'red',
                color: 'white',
                padding: '0 16px',
                borderRadius: '4 px'
              }}

            />
          )
        }
      }

    ],
    []
  );

  const {
    //globalFilter,
    pagination,
    searchTerm,
    //onChangeFilter,
    setPagination,
    //cleanFilter,

  } = useTableFilter();


  const { pageIndex, pageSize } = pagination;
  const { columnFilters, setColumnFilters, filterObject } = useTableServerSideFiltering();
  //normalizamos 
  const normalizeFilters = (filters: Record<string, any>) => {
    const result: Record<string, any> = {}
    Object.entries(filters).forEach(([key, value]) => {
      const cleanKey = key.includes('.') ? key.split('.').pop()! : key
      const mappedKey = cleanKey === 'razon_social' ? 'proveedor_razon_social' : cleanKey
      result[mappedKey] = value
    })
    return result
  }


  const { isLoading, data: solicitudPedidosEnFinalizadoRes, isRefetching, } = useFetchOrdenesCompras(
    {
      page: pageIndex + 1,
      page_size: pageSize,
      numero_referencia: searchTerm,
      estado_orden: EstadosProcesoEnumChoice.FINALIZADO,
      ...normalizeFilters(filterObject)

      //...filterObject,
      //filterByState: false,

    });



  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
      </Grid>
      <Grid item xs={12}>
        <GeneralTable<OrdenesCompra>
          columns={columns}
          data={solicitudPedidosEnFinalizadoRes?.data.data || []}
          //
          isLoading={isLoading}
          isRefetching={isRefetching}
          // // search
          enableGlobalFilter={false}
          // onGlobalFilterChange={setGlobalFilter}
          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={solicitudPedidosEnFinalizadoRes?.data?.count}
          // // actions
          actionsColumnSize={120}
          ////
          enableManualFiltering={true}
          columnFilters={columnFilters}
          onColumnFiltersChange={setColumnFilters}
          enableSorting={false}
          // crud
          enableColumnActions={true}
          enableEditing={false}
          canDelete={false}
          positionActionsColumn='first'
        />
      </Grid>
      <ScrollableDialogProps
        open={isModalOpen}
        title="Detalle Producto"
        onCloseIcon={() => setIsModalOpen(false)}
        minWidth="60%"
        contentNode={
          <>
            <Grid container spacing={2}>
              <Grid item {...gridSize}>
                <Grid item>
                  <Typography variant='subtitle2' color={"text.secondary"} fontWeight={'800'}>{'INFORMACIÓN'}</Typography>
                </Grid>
                <Grid container spacing={1} justifyContent={'flex-end'} >
                  <Grid item {...gridSize}>
                    <Grid container spacing={4}>
                      <Grid item>
                        <ShowNamesUser
                          title='Solicitud-compra'
                          icon={<PersonIcon color='info' />}
                          user={usuarioSolicitud || 'N/A'}
                        //user={solicitudPedidosEnFinalizadoRes?.data.data.find(item => item.solicitud_ingreso_data?.user)?.solicitud_ingreso_data?.user ?? 'N/A'}
                        />

                      </Grid>
                      <Grid item>
                        <ShowNamesUser
                          title='Orden-Pedido'
                          icon={<PersonIcon color='info' />}
                          user={userCreate || 'N/A'}
                        //user={solicitudPedidosEnFinalizadoRes?.data.data.find(item => item.user_create)?.user_create ?? 'N/A'}
                        />
                      </Grid>
                      {numberFactura && (
                        <Grid item>
                          <ShowNamesUser
                            title="Último Factura ingresada"
                            icon={<ReceiptLongIcon color="info" sx={{ fontSize: 25 }} />}
                            user={
                              numberFactura || 'N/A'
                              //solicitudPedidosEnFinalizadoRes?.data?.data.find(item => item.ingreso_inventario_data?.at(-1)?.numero_factura?.trim() ||
                              //item.ingreso_inventario_data?.at(-1)?.numero_guia_remision?.trim() || 'N/A')
                            }
                            texto={'#'}
                          />
                        </Grid>

                      )}

                      {numberRemision && (
                        <Grid item>
                          <ShowNamesUser
                            title="Último Remisión ingresada"
                            icon={<ReceiptLongIcon color="info" sx={{ fontSize: 25 }} />}
                            user={
                              numberRemision || 'N/A'
                            }
                            texto={'#'}
                          />
                        </Grid>

                      )}




                    </Grid>

                  </Grid>
                  <Grid item>
                    <ActionsBar
                      onDownload={handleDowload}
                      onPrint={handlePrint}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    {details.length > 0 && (
                      <SampleTable<IUbicacionProducto>
                        columns={columnsProductosDetallePedidosDb}
                        data={details}
                      />
                    )}
                  </Grid>

                </Grid>

              </Grid>

            </Grid>
          </>
        }
      />
    </Grid>
  );
}
